// Selector to get delivery zones from state
export const selectAreas = (state) => state.country?.areas;